import React from "react";
import {
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput
} from "shards-react";

export default () => (
  <div className="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
    
  </div>
);
